<template>
    <div >
      <iframe
        allow="microphone; camera"
        width="100%"
        height="600"
        :src="zoomUrl()"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
</template>
<script>
import {getZoomUrl} from "@/helpers";
import i18n from "@/i18n";
export default {
    name: "ZoomMeeting",
    props: {
        meta: {
            type: Object,
            default: null
        }
    },
    mounted() {
        this.showNotification()
    },
    methods: {
        zoomUrl() {
            return getZoomUrl(this.meta.screener_id);
        },
        /** Show notification: Event is about to start */
        showNotification() {
            this.$store.dispatch("app/showSupportNotification", {
                screener_id: this.meta.screener_id,
                message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
            });
        }
    }
}
</script>
